import { Component, OnInit, ChangeDetectionStrategy, Input, Output,  EventEmitter, ViewChild  } from '@angular/core';
import { Event, Seatingplan } from "../../../models";
import { Observable, Subscription } from 'rxjs';
import { Store } from "@ngrx/store";
import { AppState } from "../../../reducers";
import { MessageActions, EventActions } from "../../../actions";
import { EventApi, SeatingplanApi } from "../../../services/webservice"
import { EventSeatingplanPresentation } from "./event-seatingplan.presentation"

@Component({
	selector: 'event-seatingplan',
	template: `
			<event-seatingplan-presentation
			[seatingplans] = "seatingplans$ | async"
			[event] = "event"
			(eventChange) = "updateEvent($event)"
			>
			</event-seatingplan-presentation>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class EventSeatingplanComponent implements OnInit{
	private seatingplans$: Observable<Seatingplan[]>;

	private currentEventSubscribtion: Subscription;

	@Input() event: Event;
	@Output() seatingplanSelected: EventEmitter<Seatingplan> = new EventEmitter<Seatingplan>();

	@ViewChild(EventSeatingplanPresentation)
	private eventSeatingplanPresentation: EventSeatingplanPresentation;

	constructor(
		private eventApi: EventApi,
		private seatingplanApi: SeatingplanApi,
		private store: Store<AppState>,
		private messageActions: MessageActions,
		private eventActions: EventActions) { }

	ngOnInit() {
		this.seatingplans$ = this.seatingplanApi.loadSeatingplans();
		this.currentEventSubscribtion = this.store.select("eventServerState", "event", "currentEvent").subscribe((currentEvent) => {
			if (currentEvent && currentEvent.seatingplanUuid) {
				this.seatingplanApi.loadSeatingplanByUuid(currentEvent.seatingplanUuid).subscribe((seatingplan: Seatingplan) => {
					this.emitSelectedSeatingplan(seatingplan)
				})
			}
		})
	}

	ngOnDestroy() {
		this.currentEventSubscribtion.unsubscribe()
	}

	private updateEvent(event: Event) {
		this.eventApi.patchEvent(event.storageId, event).subscribe(updatedEvent => {
				this.store.dispatch(this.eventActions.eventLoaded(updatedEvent))
				this.store.dispatch(this.messageActions.displayMessage("Der Saalplan wurde erfolgreich ausgewählt!", "success"))
			}, error => {
				this.eventSeatingplanPresentation.patchForm(this.event)
				this.handleError(error)
			}
		)
	}

	private handleError(error: any) {
		if (!error.messageDe) {
			error.messageDe = "Es ist ein unerwarteter Fehler aufgetreten."
		}
		this.store.dispatch(this.messageActions.displayMessage(error.messageDe, "error"));
	}

	private emitSelectedSeatingplan(seatingplan: Seatingplan) {
		this.seatingplanSelected.emit(seatingplan)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-seatingplan/event-seatingplan.component.ts